export default "__VITE_ASSET__Dc9Mwfj1__"